import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import "./assets/sass/styles.scss";
import "./assets/themes/default/style.scss";
import "./variable.css";
import './styles.scss';
import AppRoute from './app.route';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from './app/shared/components/loader/loader';
import { toggleLoader } from './app/redux/actions/loader.action';


const App: React.FC<AppState> = (props: AppState) => {
  const { toggleLoader } = props;
  // Fix to see loader continous loading sometimes
  useEffect(() => {
    // Reset loader state on app mount to prevent stuck loader
    toggleLoader(false);
  }, [toggleLoader]);

  return (
    <>
      <Router>
        {AppRoute}
        <ToastContainer />
      </Router>
      <Loader loadPanelVisible={props.isLoaderShow} />
    </>
  );
}

const mapStateToProps = (state: any) => {
  return {
    isLoaderShow: state.appLoaderReducer.isLoaderShow
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ toggleLoader }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);

interface AppState {
  isLoaderShow: boolean;
  toggleLoader: (payload: boolean) => void;
}

